import { render, staticRenderFns } from "./AnswerOneSetting.vue?vue&type=template&id=941e2ebe&"
import script from "./AnswerOneSetting.vue?vue&type=script&lang=js&"
export * from "./AnswerOneSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports